import React from 'react';

const MenuSection = () => {
  return (
    <section className="menu-section text-white bg-black py-5">
      <div className="container text-center">
        <h2 id='services' className="mb-5 display-5">Serviços</h2>
        <div className="row">
          <div className="col-md-6">
            <h4 className="fw-bold">Cortes R$ 40</h4>
            <p className="fst-italic">
            Cortes tradicionais e modernos, que incluem: degradês e tapers, com tesoura na parte superior; penteados com pente fino; cortes à escovinha; topetes. Raspagem da nuca com espuma quente incluída e estilizada com produto
mediante solicitação.   
            </p>
          </div>
          <div className="col-md-6">
            <h4 className="fw-bold">Barba R$ 35</h4>
            <p className="fst-italic">
              Contornos precisos e modelagem personalizada. Trabalhamos com vários estilos como barba cheia, lenhador, Van Dyke, desenhada e por fazer. Estilo e cuidado em cada detalhe.
            </p>
          </div>
          <div className="col-md-6">
            <h4 className="fw-bold">Sobrancelha R$ 15</h4>
            <p className="fst-italic">
              Correção e modelagem com simetria e precisão. Realçamos o formato natural do seu rosto para um olhar mais harmonioso e expressivo.
            </p>
          </div>
          <div className="col-md-6">
            <h4 className="fw-bold">Pigmentação R$ 20 (Barba ou Cabelo)</h4>
            <p className="fst-italic">
              Corrige falhas, disfarça fios brancos e realça a cor com cobertura leve e acabamento natural, tanto na barba quanto no cabelo.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
